const formConvertFormat = (form, type) => {
    let result = {
        article_id: form.article_id, // 编辑时需要的quiz id
        quiz_category: form.category_id, // quiz分类
        tag_one: '', // tag 1
        tag_two: '', // tag 2
        tag_three_custom: [], // tag 3
        quiz_title: form.title, // quiz标题
        url_title: form.url_title, // quiz seo 跳转 url_title
        banner_image: form.img_url, // quiz banner图
        quiz_intro_info: form.introduction, // quiz intro页文案
        question_list: [],
        quiz_answer_list_string: '', // quiz答案
        quiz_answer_score_list_string: '' // quiz答案对应分数
    };
    // 标签列表转换
    form.tag_list.forEach(item => {
        if (item.tag_level === 1) {
            result.tag_one = item.tag_id;
            if (type === 'list') {
                result.tag_one_name = item.tag_name;
            }
        } else if (item.tag_level === 2) {
            result.tag_two = item.tag_id;
            if (type === 'list') {
                result.tag_two_name = item.tag_name;
            }
        } else if (item.tag_level === 3) {
            result.tag_three_custom.push(item.tag_name);
        }
    });
    // 题目转换
    form.question_list.forEach(item => {
        console.log(item.question);
        let obj = {
            quiz_question: item.question, // quiz问题
            question_id: item.question_id, // 题目id
            image: item.img_url, // quiz对应图片
            fileList: [{
                url: item.img_url
            }], // 记录上传图片的信息
            option_list_string: '', // 选项
            option_score_list_string: '' // 选项对应分数
        };
        item.options_list.forEach(element => {
            obj.option_list_string = obj.option_list_string + element.content + '\n';
            obj.option_score_list_string = obj.option_score_list_string + element.rate + '\n';
        });
        result.question_list.push(obj);
    });
    // 答案转换
    if (type === 'list') {
        result.quiz_answer = '';
        form.article_rate_list.forEach(item => {
            result.quiz_answer = result.quiz_answer + item.rate_range + '：' + item.content + '\n';
        });
    } else {
        form.article_rate_list.forEach(item => {
            result.quiz_answer_list_string = result.quiz_answer_list_string + item.content + '\n';
            result.quiz_answer_score_list_string = result.quiz_answer_score_list_string + item.rate_range + '\n';
        });
    }
    // 如果为列表页
    if (type === 'list') {
        result.tag_three_custom = result.tag_three_custom.join(';');
        result.category_name = form.category_name;
        result.status = !!form.status;
        result.update_at = form.update_at;
    }
    return result;
};

export {
    formConvertFormat
};



// WEBPACK FOOTER //
// ./src/common/tools.js